// extracted by css-extract-rspack-plugin
export default {"overlay":"Overlay-module__overlay__jq7s5"};